import { useEffect, useRef, useState } from 'react';

type UseHookParams = {
    width: number
    height: number
}

const useHook = ({ width, height }: UseHookParams) => {
  const contenedorRef = useRef<HTMLDivElement>(null);
  const [widthC, setWidthC] = useState(0);
  const [heightC, setHeightC] = useState(0);

  const getContainerSize = () => {
    const proporcion = width / height;
    const alturaNueva = height - (height * proporcion / 100);
    setWidthC(width);
    setHeightC(alturaNueva);
  };

  useEffect(() => {
    getContainerSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, height]);

  return {
    contenedorRef,
    widthC,
    heightC,
  };
};

export default useHook;
